export const regPhone = /^1[3456789]\d{9}$/;
/**
 * 检验手机号
 * @param {*} rule 规则
 * @param {*} value 输入值
 * @param {*} callback
 * @returns
 */
export const validPhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入手机号'))
  }
  if (!regPhone.test(value)) {
    return callback(new Error('手机号格式有误'));
  }
  callback();
}